import { styled } from "styled-components";

// 만족도
export const StarRatingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;
